<nb-card>
    <nb-card-header>
      <div>
        Provide the room name and the people you want to chat with
      </div>
      <button size="small" (click)="close()" nbButton ghost status="basic"><nb-icon icon="close-outline"></nb-icon></button>
    </nb-card-header>
    <nb-card-body *ngIf="show">
      <div class="row">
        <div class="col-xxxl-12 col-xxl-12 col-xl-12 col-md-12 col-sm-12">
          <div>
            <input type="text" status="primary" [(ngModel)]="text" nbInput fullWidth placeholder="Room Name...">
          </div>
        </div>
      </div>
      <div class="row pt-4">
        <div *ngIf="friends.length > 0" class="col-xxxl-12 col-xxl-12 col-xl-12 col-md-12 col-sm-12">
          <nb-select fullWidth placeholder="Select Contacts" multiple [(selected)]="selectedUsersIds">
            <nb-option *ngFor="let user of friends" [value]="user.userId">{{user.firstName}} {{user.lastName}}</nb-option>
          </nb-select>
        </div>
        <div *ngIf="friends.length === 0" class="col-xxxl-12 col-xxl-12 col-xl-12 col-md-12 col-sm-12">
          <nb-select fullWidth placeholder="No friends available" [disabled]="true"></nb-select>
        </div>
      </div>

 </nb-card-body>
 <nb-card-footer class="align">
  <button nbButton size="small" (click)="save()" status="info" [disabled]="friends.length === 0">Save</button>
</nb-card-footer>
</nb-card>

